import { useState } from "react";
import { ZoomIn, ZoomOut } from "lucide-react";
import { img } from "../lib/api";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

export default function MediaThumbs({ photos = [], videos = [], testid = "review-media" }) {
  const [open, setOpen] = useState(null);
  const [zoom, setZoom] = useState(1);
  const show = (m) => { setZoom(1); setOpen(m); };
  if (!photos.length && !videos.length) return null;
  return (
    <>
      <div className="flex flex-wrap gap-2 mt-2" data-testid={testid}>
        {photos.map((u) => <button key={u} type="button" data-testid={`${testid}-photo`} onClick={() => show({ type: "img", u })} className="rounded-lg overflow-hidden border border-white/10 hover:border-[#ff5500]"><img src={img(u)} alt="Review" loading="lazy" className="w-20 h-20 object-cover" /></button>)}
        {videos.map((u) => <button key={u} type="button" data-testid={`${testid}-video`} onClick={() => show({ type: "video", u })} className="relative rounded-lg overflow-hidden border border-white/10 hover:border-[#ff5500] bg-black"><video src={img(u)} preload="metadata" muted playsInline className="w-32 h-20 object-cover pointer-events-none" /><span className="absolute inset-0 grid place-items-center text-2xl">▶</span></button>)}
      </div>
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-3xl bg-black border-white/10 p-3" data-testid={`${testid}-lightbox`}>
          <DialogTitle className="sr-only">Review media</DialogTitle>
          {open?.type === "video" ? <video src={img(open.u)} controls autoPlay playsInline className="w-full max-h-[75vh] rounded-xl bg-black" data-testid={`${testid}-lightbox-video`} /> : open && (
            <>
              <div className="overflow-auto max-h-[75vh] rounded-xl"><img src={img(open.u)} alt="Review" style={{ transform: `scale(${zoom})`, transformOrigin: "top left" }} className="w-full transition-transform cursor-zoom-in" onClick={() => setZoom((z) => (z >= 3 ? 1 : z + 1))} data-testid={`${testid}-lightbox-img`} /></div>
              <div className="flex justify-center gap-2">
                <button type="button" data-testid={`${testid}-zoom-out`} onClick={() => setZoom((z) => Math.max(1, z - 0.5))} className="p-2 rounded-full bg-white/10"><ZoomOut size={16} /></button>
                <span className="text-xs self-center">{Math.round(zoom * 100)}%</span>
                <button type="button" data-testid={`${testid}-zoom-in`} onClick={() => setZoom((z) => Math.min(4, z + 0.5))} className="p-2 rounded-full bg-white/10"><ZoomIn size={16} /></button>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
